<template>
  <div class="switch-container d-flex flex-column">
    <div class="d-flex flex-row">
      <div class="toggle-title">{{ title }}</div>
    </div>
    <div class="d-flex flex-row">
      <div class="toggle-title power-off" :class="title">
        <font-awesome-icon class="icon power-off-highlight" :icon="icon"/>
      </div>
      <div>
        <label class="switch">
          <input type="checkbox">
          <span class="slider round"></span>
        </label>
      </div>
      <div class="toggle-title power-on" :class="title">
        <font-awesome-icon class="icon power" :icon="icon"/>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: "ToggleSwitch",
  props: {
    title: String,
    icon: String,
    state: Boolean
  },
  watch: {
    state: function (newVal) { // watch it
      let iconOn = document.getElementsByClassName('toggleTitle power-on ' + this.title)[0].firstChild;
      let iconOff = document.getElementsByClassName('toggleTitle power-off ' + this.title)[0].firstChild;
      if (newVal === true) {
        iconOn.classList.remove('power');
        iconOn.classList.add('power-on-highlight');
        iconOff.classList.remove('power-off-highlight');
        iconOff.classList.remove('power-on-highlight');
        iconOff.classList.add('power');
      } else {
        iconOff.classList.remove('power');
        iconOff.classList.add('power-off-highlight');
        iconOn.classList.remove('power-off-highlight');
        iconOn.classList.remove('power-on-highlight');
        iconOn.classList.add('power');
      }
    }
  }
}
</script>

<style scoped>
.switch-container {
  display: flex;
  flex-direction: row;
  padding: 5px;
}

.toggle-title {
  margin-top: 3px;
  padding: 6px 10px 10px 10px;
}

.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 34px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: .4s;
  transition: .4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 26px;
  width: 26px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: .4s;
  transition: .4s;
}

input:checked + .slider {
  background-color: #16cdbe;
}

input:focus + .slider {
  box-shadow: 0 0 1px #16cdbe;
}

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}

.power-on-highlight {
  color: #16cdbe;
}

.power-off-highlight {
  color: #b24444;
}

.power {
  color: rgba(255, 255, 255, 0.44);
}
</style>